import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { getData } from "./data"
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import * as moment from "moment";

function Table(props) {
  const { data } = props
  const columns = [
    {
      dataField: "shops",
      text: "ID",
      sort: true,
    },
    {
      dataField: "bets",
      text: "PIN",
      sort: true,
    },
    {
      dataField: "total_stake",
      text: "User",
      sort: true,
    },
    {
      dataField: "total_stake",
      text: "Channel",
      sort: true,
    },
    {
      dataField: "total_stake",
      text: "Product",
      sort: true,
    },

    {
      dataField: "effective_stake",
      text: "BetType",
      sort: true,
    },
    {
      dataField: "wht",
      text: "DateTime",
      sort: true,
    },

    {
      dataField: "net_payout",
      text: "Stake",
      sort: true,
    },

    {
      dataField: "GGR",
      text: "Stake Tax",
      sort: true,
    },
    {
      dataField: "GGR_ratio",
      text: "Bonus",
      sort: true,
      // formatter: (cellContent, row) => {
      //   return <div className="text-body fw-bold">{row.GGRRatio}</div>
      // },
    },
    {
      dataField: "GGR",
      text: "WHT",
      sort: true,
    },
    {
      dataField: "GGR",
      text: "NetWin",
      sort: true,
    },
    {
      dataField: "GGR",
      text: "Status",
      sort: true,
    },
  ]

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: 10,
    totalSize: getData().length,
    custom: true,
  }

  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Kiron Tickets"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="6">
                        <Row>
                          <Col sm="6">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                          <Col sm="6">
                            <div>
                              <ReactHTMLTableToExcel
                                  id="test-table-xls-button"
                                  className="download-table-xls-button w-md btn btn-primary"
                                  table="table-to-xls"
                                  filename={`Kiron-Report-${moment(new Date()).format("DD/MM/YYYY")}`}

                                  sheet="tablexls"
                                  buttonText="Download"
                                  type="button"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}></Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable id="table-to-xls"
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </>
  )
}

export default Table
